export class SummaryOrderModel {
    public totalAmountStoreVN!: number;
    public totalLeftStoreVN!: number;
    public totalAmountNotDeposit!: number;
    public totalNeedDeposit!: number;
    public totalAmountStoreCN!: number;
    public TotalExported!: number;
    public TotalExportedNotPay!: number;
    public TotalStatusAll!: number;
    public TotalStatus0!: number;
    public TotalStatus1!: number;
    public TotalStatus2!: number;
    public TotalStatus3!: number;
    public TotalStatus5!: number;
    public TotalStatus7!: number;
    public TotalStatus9!: number;
    public TotalStatus10!: number;
    public TotalStatus11!: number;
    public TotalStatus12!: number;
    public TotalStatus13!: number;
    public TotalStatus16!: number;
}